import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useWorkspace } from '../../utils/WorkspaceContext';

const CreateSprintGoalDialog = ({ open, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    track: '',
    sprint: '',
    goal: '',
  });
  const [tracks, setTracks] = useState([]);
  const [sprints, setSprints] = useState([]);
  const { currentWorkspace } = useWorkspace();

  useEffect(() => {
    const fetchTracksAndSprints = async () => {
      try {
        const tracksResponse = await api.get('tracks/', {params: {workspace_id: currentWorkspace.id}});
        setTracks(tracksResponse.data);
        const sprintsResponse = await api.get('sprints/', {params: {workspace_id: currentWorkspace.id}});
        setSprints(sprintsResponse.data);
      } catch (error) {
        console.error('Error fetching tracks or sprints:', error);
      }
    };

    fetchTracksAndSprints();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.workspace = currentWorkspace.id;
    try {
      await api.post('sprint-goals/', formData);
      onSuccess();
    } catch (error) {
      console.error('Error creating sprint goal:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Sprint Goal</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Select
            margin="dense"
            label="Track"
            fullWidth
            required
            value={formData.track}
            onChange={(e) => setFormData({ ...formData, track: e.target.value })}
          >
            {tracks.map((track) => (
              <MenuItem key={track.id} value={track.id}>
                {track.name}
              </MenuItem>
            ))}
          </Select>
          <Select
            margin="dense"
            label="Sprint"
            fullWidth
            required
            value={formData.sprint}
            onChange={(e) => setFormData({ ...formData, sprint: e.target.value })}
          >
            {sprints.map((sprint) => (
              <MenuItem key={sprint.id} value={sprint.id}>
                {`${sprint.name} (${sprint.start || '??'} - ${sprint.end || '??'})`}
              </MenuItem>
            ))}
          </Select>
          <TextField
            margin="dense"
            label="Goal"
            fullWidth
            required
            multiline
            rows={4}
            value={formData.goal}
            onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained">Create</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateSprintGoalDialog;